jQuery(document).ready(function ($) {
    // helpers
    // function anyTagsChecked() {
    //     var any_checked = false;
    //     var tag_boxes = $('input[name^=tags]');

    //     for (var i = 1; i < tag_boxes.length; i++) {
    //         any_checked = any_checked || tag_boxes[i].checked;
    //     }

    //     return any_checked;
    // }

    // function anyTypesChecked() {
    //     var any_checked = false;
    //     var type_boxes = $('input[name^=types]');

    //     for (var i = 1; i < type_boxes.length; i++) {
    //         any_checked = any_checked || type_boxes[i].checked;
    //     }

    //     return any_checked;
    // }

    // function unCheckTags() {
    //     var tag_boxes = $('input[name^=tags]');

    //     for (var i = 1; i < tag_boxes.length; i++) {
    //         tag_boxes[i].checked = false;
    //     }

    //     return true;
    // }

    // function unCheckTypes() {
    //     var type_boxes = $('input[name^=types]');

    //     for (var i = 1; i < type_boxes.length; i++) {
    //         type_boxes[i].checked = false;
    //     }

    //     return true;
    // }

    function serializeObj(obj, prefix) {
        var str = [];
        var p;

        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + "[" + p + "]" : p,
                v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                serializeObj(v, k) :
                encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }

        return str.join("&");
    }

    // // types all
    // $(document).on("click", "input[name='types|all_articles']", function (e) {
    //     if (this.checked) {
    //         unCheckTypes();
    //     }
    //     else {
    //         if (!anyTypesChecked()) {
    //             e.preventDefault();
    //         }
    //     }
    // });

    // // types rest
    // $(document).on("click", "input[name^=types]:not([name='types|all_articles'])", function (e) {
    //     var all_types = $("input[name='types|all_articles']");

    //     if (this.checked) {
    //         if (all_types.attr('checked') == 'checked') {
    //             all_types.prop('checked', false);
    //         }
    //     }
    //     else {
    //         if (!anyTypesChecked()) {
    //             all_types.prop('checked', true);
    //         }
    //     }
    // });

    // // tags all
    // $(document).on("click", "input[name='tags|all_tags']", function (e) {
    //     if (this.checked) {
    //         unCheckTags();
    //     }
    //     else {
    //         if (!anyTagsChecked()) {
    //             e.preventDefault();
    //         }
    //     }
    // });

    // // tags rest
    // $(document).on("click", "input[name^=tags]:not([name='tags|all_tags'])", function (e) {
    //     var all_tags = $("input[name='tags|all_tags']");

    //     if (this.checked) {
    //         if (all_tags.attr('checked') == 'checked') {
    //             all_tags.prop('checked', false);
    //         }
    //     }
    //     else {
    //         if (!anyTagsChecked()) {
    //             all_tags.prop('checked', true);
    //         }
    //     }
    // });

    // filter
    $('#filterArticleType').on("change", function (e) {
        e.preventDefault();

        var form = $(this);
        var action = form.attr('action');
        var data = {};

        form.serializeArray().map(function(input){
            var parts = input.value.split('|');
            var type = parts[0];
            var name = parts[1];

            if (data.hasOwnProperty(type)){
                data[type] += ','+name;
            }
            else {
                data[type] = name
            }
        });

        var csrfToken = $('[name="csrf-token"]').attr('content');

        $.ajax({
            type: "GET",
            url: action,
            data: data,
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            },
            success: function (response) {
                if (response.status == 'success') {
                    var url = response.locale ? '/' + response.locale : '';
                    url += '/resources?' + serializeObj(data);

                    $("#results").html(response.results);

                    window.history.pushState('', '', url);
                    // console.log('success', url);
                    // window.location = window.history.state;

                    // make the results fadeup
                    document.querySelectorAll('#results .fadeup-group').forEach((fadeupGroup) => {
                        new Waypoint({
                            element: fadeupGroup,
                            handler(direction) {
                                if (direction === `down`) {
                                    fadeupGroup.classList.add(`is-inview`)
                                    this.destroy()
                                }
                            },
                            offset: `80%`,
                        })
                    })
                }
            },
        });

        window.history.pushState('', '', window.location.origin + window.location.pathname + '?' + serializeObj(data));
        // console.log('submit', window.location.origin + window.location.pathname + '?' + serializeObj(data));
    });

    // avoid json response displayed in the browser
    $(document).on("click", ".resource-card", function (e) {
        // console.log('click', window.location);
        window.history.pushState('', '', window.location);
    });

});
